import React, {useMemo, useRef} from "react";
import {PnlBars} from "./PnlBars.jsx";
import {PnlCurve} from "./PnlCurve.jsx";

function ChartCard({title, description, children}) {
    return (
        <section className="panel chart-card">
            <div className="chart-card-head">
                <h2>{title}</h2>
                <p>{description}</p>
            </div>
            <div className="chart-card-content">{children}</div>
        </section>
    );
}

export function PnlCharts({dailyPnl}) {
    const series = useMemo(() => {
        let cumulativePnl = 0;
        return [...(dailyPnl || [])].sort((left, right) => left.date.localeCompare(right.date)).map((point) => {
            const pnl = Number(point.netPnl) || 0;
            cumulativePnl += pnl;
            return {...point, pnl, cumulativePnl};
        });
    }, [dailyPnl]);
    const seriesKey = useMemo(() => series.map((point) => `${point.date}:${point.pnl}:${point.cumulativePnl}`).join("|"), [series]);
    const previousSeriesKey = useRef(null);
    const animate = previousSeriesKey.current === null || previousSeriesKey.current !== seriesKey;
    previousSeriesKey.current = seriesKey;

    if (!series.length) return <div className="panel empty">No daily P&L reported for YTD.</div>;
    return (
        <div className="pnl-charts">
            <ChartCard title="Cumulative PnL" description="Running total of profits and losses over time"><PnlCurve dailyPnl={series} animate={animate}/></ChartCard>
            <ChartCard title="Daily Trading PnL" description="Profit and loss breakdown by day over YTD"><PnlBars dailyPnl={series} animate={animate}/></ChartCard>
        </div>
    );
}
